import { render, staticRenderFns } from "./InfoQuery.vue?vue&type=template&id=0a94ecd6&scoped=true&"
import script from "./InfoQuery.vue?vue&type=script&lang=js&"
export * from "./InfoQuery.vue?vue&type=script&lang=js&"
import style0 from "./InfoQuery.vue?vue&type=style&index=0&id=0a94ecd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a94ecd6",
  null
  
)

export default component.exports